import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { createWorkDetail, getWorkDetails, updateWorkDetail, deleteWorkDetail } from "../../api/const";
import { getActivitiesByDate } from "../../api/process";

export default function WorkDetailPage() {
    const today = new Date().toLocaleDateString("sv-SE"); 
    const { id: projectId } = useParams();

    const [date, setDate] = useState(today);
    const [rows, setRows] = useState([{ activity: "", content: "" }]);
    const [saving, setSaving] = useState(false);
    const [activities, setActivities] = useState([]);
    const [existing, setExisting] = useState([]); // ✅ 저장된 작업

    // 활동 불러오기
    useEffect(() => {
        (async () => {
            try {
                const data = await getActivitiesByDate(date);
                setActivities(data.results || data);
            } catch (err) {
                console.error("활동 불러오기 실패", err);
            }
        })();
    }, [date]);

    // 저장된 상세작업 불러오기
    useEffect(() => {
        if (!projectId || !date) return;
        (async () => {
            try {
                const data = await getWorkDetails(date);
                console.log(data)
                setExisting(data.results);
            } catch (err) {
                console.error("상세작업 불러오기 실패", err);
            }
        })();
    }, [date]);

    // 행 추가
    const addRow = () => setRows([...rows, { activity: "", content: "" }]);

    // 행 업데이트
    const updateRow = (index, field, value) => {
        const next = [...rows];
        next[index][field] = value;
        setRows(next);
    };

    // 저장
    const save = async () => {
        if (!date) {
            alert("작업일을 선택하세요.");
            return;
        }
        setSaving(true);
        try {
            for (const row of rows) {
                if (!row.activity || !row.content) continue;
                await createWorkDetail({
                    project: projectId,
                    activity: row.activity,
                    date,
                    content: row.content,
                });
            }
            alert("저장 완료!");
            setRows([{ activity: "", content: "" }]);

            // ✅ 다시 불러오기
            const data = await getWorkDetails(date);
            setExisting(data.results);
        } catch (err) {
            console.error(err);
            alert("저장 중 오류 발생");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="p-6 space-y-6 mx-auto">
            <h2 className="text-lg font-semibold">상세작업 입력</h2>

            {/* 작업일 선택 */}
            <div>
                <label className="block text-sm text-slate-600 mb-1">작업일</label>
                <input
                    type="date"
                    value={date}
                    onChange={(e) => {
                        setDate(e.target.value);
                        setRows([{ activity: "", content: "" }]);
                    }}
                    className="border p-2 rounded w-full"
                />
            </div>

            {/* 기존 저장된 상세작업 */}
            <div>
                <h3 className="text-sm font-medium text-slate-700 mb-2">저장된 작업</h3>
                {existing.length ? (
                    <ul className="space-y-2">
                        {existing.map((w) => (
                            <li
                                key={w.id}
                                className="relative p-2 border rounded bg-white shadow-sm "
                                onClick={() =>
                                    setExisting((prev) =>
                                        prev.map((x) =>
                                            x.id === w.id ? { ...x, _editing: true } : x
                                        )
                                    )
                                }
                            >
                                {/* 삭제 버튼 (오른쪽 상단 X) */}
                                {!w._editing && (
                                    <button
                                        className="absolute top-1 right-1 text-slate-400 hover:text-red-500"
                                        onClick={async (e) => {
                                            e.stopPropagation(); // li onClick 막기
                                            if (window.confirm("삭제하시겠습니까?")) {
                                                await deleteWorkDetail(w.id);
                                                const data = await getWorkDetails(date);
                                                setExisting(data.results);
                                            }
                                        }}
                                    >
                                        ✕
                                    </button>
                                )}

                                {w._editing ? (
                                    <>
                                        {/* 수정 모드 */}
                                        <div className="space-y-2">
                                            <select
                                                value={w.activity}
                                                onChange={(e) =>
                                                    setExisting((prev) =>
                                                        prev.map((x) =>
                                                            x.id === w.id ? { ...x, activity: e.target.value } : x
                                                        )
                                                    )
                                                }
                                                className="w-full border border-slate-300 rounded-lg p-2 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                            >
                                                {activities.map((a) => (
                                                    <option key={a.id} value={a.id}>
                                                        {a.name}
                                                    </option>
                                                ))}
                                            </select>
                                            <textarea
                                                value={w.content}
                                                onChange={(e) =>
                                                    setExisting((prev) =>
                                                        prev.map((x) =>
                                                            x.id === w.id ? { ...x, content: e.target.value } : x
                                                        )
                                                    )
                                                }
                                                className="border p-2 rounded w-full text-sm"
                                            />
                                            <div className="flex gap-2 mt-1">
                                                <button
                                                    className="px-2 py-1 bg-indigo-600 text-white rounded text-xs"
                                                    onClick={async (e) => {
                                                        e.stopPropagation();
                                                        await updateWorkDetail(w.id, {
                                                            project: projectId,
                                                            activity: w.activity,
                                                            date,
                                                            content: w.content,
                                                        });
                                                        const data = await getWorkDetails(date);
                                                        setExisting(data.results);
                                                    }}
                                                >
                                                    저장
                                                </button>
                                                <button
                                                    className="px-2 py-1 bg-gray-200 rounded text-xs"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setExisting((prev) =>
                                                            prev.map((x) =>
                                                                x.id === w.id ? { ...x, _editing: false } : x
                                                            )
                                                        );
                                                    }}
                                                >
                                                    취소
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        {/* 보기 모드 */}
                                        <div className="text-sm font-semibold">{w.activity_name}</div>
                                        <div className="text-sm text-slate-600 whitespace-pre-line">
                                            {w.content}
                                        </div>

                                    </>
                                )}
                            </li>
                        ))}
                    </ul>

                ) : (
                    <p className="text-sm text-slate-400">저장된 작업이 없습니다.</p>
                )}
            </div>
            {/* 반복 입력 */}
            <div className="space-y-3">
                {rows.map((row, idx) => (
                    <div
                        key={idx}
                        className="border p-3 rounded space-y-2 bg-slate-50"
                    >
                        {/* Activity 선택 */}
                        <select
                            value={row.activity}
                            onChange={(e) => updateRow(idx, "activity", e.target.value)}
                            className="w-full border border-slate-300 rounded-lg p-2 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                        >
                            <option value="">Activity 선택</option>
                            {activities.map((a) => (
                                <option key={a.id} value={a.id}>
                                    {a.name}
                                </option>
                            ))}
                        </select>

                        {/* 작업 내용 */}
                        <textarea
                            value={row.content}
                            onChange={(e) => updateRow(idx, "content", e.target.value)}
                            className="border p-2 rounded w-full text-sm"
                            placeholder="작업 상세 내용을 입력하세요"
                        />
                    </div>
                ))}
            </div>

            {/* 버튼 */}
            <div className="flex gap-2">
                <button
                    type="button"
                    onClick={addRow}
                    className="px-3 py-2 bg-gray-100 border rounded hover:bg-gray-200"
                >
                    + 추가
                </button>
                <button
                    type="button"
                    onClick={save}
                    disabled={saving}
                    className="px-3 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 disabled:opacity-50"
                >
                    저장
                </button>
            </div>
        </div>
    );
}
